import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import discountAction from "../../../redux/discounts/actions";
import { useProjectState } from "../../../context/stateContext";
import DiscountPreferencesTable from "../../../components/User/DiscountsReferencesComponent/DiscountPreferencesTable";
import DatePickerComponent from "../../../components/Common/DatePicker/DatePicker";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import "./index.css";

const { getDiscountsReferences } = discountAction;

const DiscountReferences = () => {
  const { selectedOrganization, startDate, endDate } = useProjectState();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getDiscountsReferences(startDate, endDate));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization]);

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(getDiscountsReferences(startDate, endDate));
    }, 1000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  return (
    <>
      <PageHeader text="Информация за Използвани Отстъпки" date={true} />
      <div className="discount-references-date-picker-container">
        <DatePickerComponent />
      </div>
      <DiscountPreferencesTable />
    </>
  );
};

export default DiscountReferences;
